if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));




    $('.sym-slides').slick({
        accessibility: false,
		responsive: [
			{
			  breakpoint: 1000,
			  settings: {
					adaptiveHeight:true
			  }
			}
		]
    });
	$('.carousel-slides').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		accessibility:true,
  		centerPadding: '150px',
		centerMode: true,
  		variableWidth: true,
		  responsive: [
			{
			  breakpoint: 1200,
			  settings: {
				centerPadding: '70px',
			  }
			},
			{
				breakpoint: 600,
				settings: {
				  centerPadding: '0px',
				  adaptiveHeight:true
				}
			}
		]
	});

	//footer back
	// let footerBack = document.getElementsByClassName('js-back')[0];
	// footerBack.addEventListener('click', function(){
	// 	animateTo('content')
	// });
 

	
    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
	   for(let j = 0; j < allffields.length; j++){
		   
		   if(allffields[j].getElementsByTagName('input').length > 0){
			   if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
				   allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
					   this.parentElement.classList.add('moved');
				   })
			   }
		   }
		   if(allffields[j].getElementsByTagName('select').length > 0){
			   allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
		   if(allffields[j].getElementsByTagName('textarea').length > 0){
			   allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
	   }
	}

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}
	}

	if(document.getElementById('footerNav')){
		let footerLinks = document.getElementById('footerNav').getElementsByTagName('a');
		let footerLogos = document.getElementById('footerLogos').getElementsByTagName('ul');
		for(let i= 0; i < footerLinks.length; i++){
			footerLinks[i].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				for(let j= 0; j < footerLogos.length; j++){
					footerLogos[j].classList.remove('active');
					footerLinks[j].classList.remove('active');
				}
				document.getElementById(currentTarget).classList.add('active');
				this.classList.add('active');
				
			})
		}
	}

	// contact form spa validation change on send to
	// if(document.getElementById('form_id-134')){
	// 	let contactForm = document.getElementById('form_id-134');
	// 	let contactFormSendTo = document.getElementById('sendto_134');
	// 	let contactFormSelect = contactForm.getElementsByTagName('select')[0];

	// 	let contactList = [
	// 		['Away Spa at W London','awayspalondon@whotels.com'],
	// 		['One Spa Edinburgh','info@onespa.com'],
	// 		['The Spa at Hanbury Manor Marriott Hotel & Country Club','mhrs.stngs.spa@marriotthotels.com'],
	// 		['Tudor Park Marriott Spa','mhrs.tdmgs.health.beauty.dept@marriotthotels.com'],
	// 		['Birmingham Leisure Club & Spa','mhrs.bhxbh.leisure@marriotthotels.com'],
	// 		['The Beauty Rooms','mhrs.cwlgs.leisure@marriotthotels.com'],
	// 		['The Priory Retreat','mhrs.emags.spa@marriotthotels.com'],
	// 		['Bexleyheath Marriott Spa','Jayne.bowen@marriotthotels.com'],
	// 		['Spa of Senses','mhrs.mangs.spa@marriotthotels.com'],
	// 		['Four Seasons Spa','dhr.manda.spa.reception@deltahotels.com'],
	// 		['St. Pancras Spa','spa.stpancras@renaissancehotels.com'],
	// 		['Cedarwood Spa','mhrs.bhxbh.leisure@marriotthotels.com']
	// 	]; 

	// 	contactFormSelect.addEventListener('change', function(){
	// 		let currentSpa = this.value;
	// 		for(let i = 0; i < contactList.length; i++){
	// 			if(contactList[i][0] == currentSpa){
	// 				contactFormSendTo.value = contactList[i][1];
	// 			}
	// 		}
	// 	})
	// }

})();

//vanilla js scroll TO animation
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}


